export default "//cdn.scentbird.com/assets/frontbird-site/images/american-express_2126af.png";